import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import { GET_METRICS } from "./actionTypes";

import { setMetrics, metricsError } from "./actions";

import axios from "axios";

function* getMetrics() {
  try {
    const response = yield call(axios.get, "/goal-user");
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setMetrics(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(metricsError(message));
  }
}

export function* watchGetMetrics() {
  yield takeEvery(GET_METRICS, getMetrics);
}

function* authSaga() {
  yield all([fork(watchGetMetrics)]);
}

export default authSaga;
